var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomPanel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 33 33",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 24,
    width: 9,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    y: 24,
    width: 9,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 9,
    height: 9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomPanel);
export default __webpack_public_path__ + "static/media/bottom-panel.5aeff736ba373bbfc59c22b51a99b435.svg";
export { ForwardRef as ReactComponent };